const mindboxEvents = {
    EditCustomer: 'EditCustomer',
    RegisterCustomer: 'RegisterCustomer',
    AuthorizeCustomer: 'AuthorizeCustomer',
    OrderAction: 'OrderAction',
    CreateAuthorizedOrder: 'CreateAuthorizedOrder',
    UpdateOrderStatus: 'UpdateOrderStatus',
    CreateorUpdateAuthorizedOrder: 'CreateorUpdateAuthorizedOrder',
    ManualCreateorUpdateOrder: 'ManualCreateorUpdateOrder'
};

module.exports = mindboxEvents;
